<script>
import {defineComponent} from 'vue'
import WishListProduct from "@/features/wishlist/WishListProduct.vue";
import blockElementMixin from "@/mixins/blockElementMixin";
import {calcCols} from "@/features/wishlist/WishListHelpers";
import {mapGetters, mapState} from "vuex";

export default defineComponent({
	name: "WishListCard",
	components: {WishListProduct},
	mixins: [blockElementMixin],


	mounted() {
		this.blockData.colSpan = this.flyerOrientation === 'vertical' ? this.currentGridMode?.colCount : this.cols;
	},

	computed: {
		...mapGetters(['content', 'language']),
		...mapGetters('wishListStore', ['userFirstName']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('scale', ['defPage']),
		...mapGetters('wishListStore', {allProds: 'products'}),
		...mapState('wishListStore', ['config']),

		lang() {
			return this.content?.feature?.wishlist || {};
		},
		currentGridMode() {
			return this.defPage.grids?.[this.displayMode];
		},
		products() {
			if(this.flyerOrientation === 'vertical') return this.allProds;
			return this.blockData?.props?.products || [];
		},
		cols() {
			const pc = this.products.length;
			return calcCols(pc, this.defPage.grids, this.flyerOrientation, this.displayMode);
			//return pc % 2 === 0 ?  (pc / 2) + 1 : (pc + 1) / 2;
		},
		colMode() {
			return this.products.length % 2 === 0 ? 'even' : 'odd';
		},
		style(){
			const cols = this.config?.cols?.[this.displayMode] || this.config?.cols?.[this.flyerOrientation] || this.cols;
			if(this.flyerOrientation === 'vertical') {

				return {
					gridTemplateColumns: `repeat(${cols}, 1fr)`,
					gridTemplateRows: `60px 1fr`,
				}
			}
			return {
				gridTemplateColumns: `repeat(${cols}, 1fr)`,
			}
		},
		ariaLabel(){
			return `${this.lang.priceDrop}, ${this.userFirstName} ${ this.lang.itemsIn }!`
		}
	},
	watch:{
		flyerOrientation(o){
			this.blockData.colSpan = o === 'vertical' ? this.currentGridMode?.colCount : this.cols;
		},
		displayMode(){
			this.blockData.colSpan = this.flyerOrientation === 'vertical' ? this.currentGridMode?.colCount : this.cols;
		}
	}
})
</script>

<template>
	<div class="wish-list-card" :class="colMode" :style="style" :lang="language">
		<div class="price-drop-title-block" :aria-label="ariaLabel">
			<div class="title">
				<img class="triangle" src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='66' height='46' viewBox='0 0 66 46' fill='none'><path d='M63.6828 0H2.06715C0.841886 0 0.133489 1.38948 0.853204 2.38109L31.6609 44.8274C32.2598 45.6527 33.4898 45.6527 34.0888 44.8274L64.8968 2.3811C65.6165 1.38948 64.9081 0 63.6828 0Z' fill='%23A21604'/></svg>"  alt=""/>
				<span>{{ lang.priceDrop }}</span>
			</div>
			<div class="caption">{{userFirstName}}{{ lang.itemsIn }}!</div>
		</div>
		<wish-list-product v-for="product in products"
		                   :key="product.code"
		                   :product="product"/>
	</div>
</template>

<style lang="scss" scoped>
.wish-list-card {
  background-color: #FFEC94;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 10px;
  padding: 10px;

  .price-drop-title-block {
    .caption {
      word-break: break-word;
    }
  }

  [flyer-orientation=vertical] & .price-drop-title-block {
	grid-area: auto / 1 / auto / -1;
	flex-direction: row;
	margin: -10px -10px 0px;
	justify-content: left;
	background-position: 5.5em 51%;
	background-size: 4em;
	[mode=mobile] & {
      flex-direction: column;
	  align-items: flex-start;
	  gap: 0.8em;
	  padding-top: 0;
	  padding-bottom: 0;
	  justify-content: center;
	  line-height: normal;
	  background-position: 5.5em 25%;
	  font-size: 12px;
    }

    .title {
	  /*padding-top: 3px;*/
      line-height: normal;
      white-space: nowrap;
      .triangle {
		bottom: 0;
		height: 1em;
		left: 1.83em;
	  }
    }
    .caption {
      line-height: normal;
      font-size: 1.14em;
	}
  }

  [flyer-orientation=horizontal] &.even {
	.price-drop-title-block {
	  grid-area: span 2;
	  background-position: 1em 44.5%
	}
  }

  .price-drop-title-block {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1.5em;
	padding: 1.2em;
	font-size: 15px;
    color: #fff;
    background-color: #D81E05;
	/*background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='66' height='46' viewBox='0 0 66 46' fill='none'><path d='M63.6828 0H2.06715C0.841886 0 0.133489 1.38948 0.853204 2.38109L31.6609 44.8274C32.2598 45.6527 33.4898 45.6527 34.0888 44.8274L64.8968 2.3811C65.6165 1.38948 64.9081 0 63.6828 0Z' fill='%23A21604'/></svg>");
	background-repeat: no-repeat;
	background-position: 1em 28.957%;
	background-size: 3.2em;*/
    font-family: 'CTEastmanCondensed',sans-serif;
    font-weight: 500;
    line-height: 1.5em;
    .title {
      font-size: 2.4em;
      font-family: 'CTEastmanCompressed',sans-serif;
      font-weight: 800;
      line-height: 0.8em;
      text-transform: uppercase;
      position: relative;
      span {
        position: relative;
      }
      .triangle {
        position: absolute;
		bottom: -0.003em;
		height: 0.9em;
		left: -0.1em;
      }

    }
  }
}
</style>
